var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-danger gap-2",attrs:{"type":"button","disabled":_vm.disabled,"loading":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('HeartIcon',{staticClass:"w-5 h-5"}),_vm._v(" "),_c('span',{staticClass:"sr-only xs:not-sr-only"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }